import { Power, PowerOff, Server } from 'lucide-react';

// Top strip: is the table open, and are the live servers linked (all players on one game server)?
export const DsfStatusBar = ({ settings, live }) => {
    const servers = live?.servers;
    const linked = servers ? servers.linked : null;
    return (
        <div className="flex flex-wrap gap-3" data-testid="dsf-status-bar">
            <div className={`flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-bold ${settings?.enabled ? 'bg-[#39FF14]/10 text-[#39FF14]' : 'bg-red-500/15 text-red-300'}`}
                data-testid="dsf-status-open">
                {settings?.enabled ? <Power className="h-4 w-4" /> : <PowerOff className="h-4 w-4" />}
                {settings ? (settings.enabled ? 'Open to players' : 'Closed — tile hidden, no new shots') : 'Loading…'}
                <span className="font-normal text-white/50">(switch: Games → Availability)</span>
            </div>
            <div className={`flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-bold ${linked === false ? 'bg-amber-500/15 text-amber-300' : 'bg-white/5 text-white/80'}`}
                data-testid="dsf-status-servers">
                <Server className="h-4 w-4" />
                {servers ? `${servers.count} server${servers.count === 1 ? '' : 's'} · ${linked ? `all players on one game server${servers.routes?.length ? ` (via ${servers.routes.join(', ')}${servers.relay_ms ? `, ${servers.relay_ms} ms` : ''})` : ''}` : 'servers NOT linked — players may drop'}` : 'Checking servers…'}
            </div>
            <div className="flex items-center rounded-lg bg-white/5 px-3 py-2 text-sm font-bold text-white/80" data-testid="dsf-status-online">
                {live ? `${live.players_online} playing now` : '—'}
            </div>
        </div>
    );
};
